import { isUnauthenticated } from "~/utils/gqlHelpers";
import { setNotFound } from "~/utils/notFound";

export const getRedirectPath = () => {
  const currentPath = window.location.pathname;
  const loginPath = { name: "Login" };
  if (currentPath !== "/") {
    loginPath.query = {
      redirect: `${window.location.pathname}${window.location.search}`,
    };
  }
  return loginPath;
};

export const pathAfterLogin = (context) => {
  const redirectTo = context.$route.query.redirect;
  if (redirectTo) return redirectTo;
  const firstInstitutionNumber = context.tokenData.fguInstitutions[0].institutionNumber;
  return { name: "Homepage", params: { fguInstitutionNumber: firstInstitutionNumber } };
};

/**
 * What a route guard should do when its access query fails.
 *
 * The guards run on the initial navigation, before LogInBarrier has renewed the
 * session, so the query goes out without a token and the schema refuses it from
 * `Query.authorized?`. That refusal says nothing about the user's access, so the
 * navigation has to go through and the barrier signs the user in. Anything else is
 * a real failure and the destination answers 404 in place.
 */
export const notFoundForFailedAccessQuery = (error, to) => {
  if (!isUnauthenticated(error)) setNotFound(to);

  return true;
};
